export default function (instance) {
  return {
    create(userId, body, config = {}) {
      return instance.post(`users/${userId}/transactions`, body, config);
    },
  };
}
